/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetMasTheadCollection
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetMasTheadCollectionQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetMasTheadCollectionQuery>({ ...options, query: Operations.GetMasTheadCollectionDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetMasTheadCollection = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetMasTheadCollectionQuery, TypescriptOperationsGenerated.GetMasTheadCollectionQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetMasTheadCollectionDocument, options);
};
export type PageGetMasTheadCollectionComp = React.FC<{data?: TypescriptOperationsGenerated.GetMasTheadCollectionQuery, error?: Apollo.ApolloError}>;
export const withPageGetMasTheadCollection = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetMasTheadCollectionQuery, TypescriptOperationsGenerated.GetMasTheadCollectionQueryVariables>) => (WrappedComponent:PageGetMasTheadCollectionComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetMasTheadCollectionDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetMasTheadCollection = {
      getServerPage: getServerPageGetMasTheadCollection,
      withPage: withPageGetMasTheadCollection,
      usePage: useGetMasTheadCollection,
    }